export default __webpack_public_path__ + "static/media/eat_healthy.16e80ed5.svg";